import { register, init, getLocaleFromNavigator, _, isLoading, locale } from 'svelte-i18n';

register('en', () => import('../locales/en.json'));
register('it', () => import('../locales/it.json'));

const SUPPORTED_LOCALES = ['en', 'it'];
const LOCALE_STORAGE_KEY = 'webdeploy.locale';

/**
 * Get the best matching locale.
 * Priority: localStorage > navigator > fallback
 */
function getLocale() {
  // Check localStorage first
  const savedLocale = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (savedLocale && SUPPORTED_LOCALES.includes(savedLocale)) {
    console.log(`🌍 Using saved locale: ${savedLocale}`);
    return savedLocale;
  }

  // Fall back to navigator locale
  const navigatorLocale = getLocaleFromNavigator();

  if (!navigatorLocale) {
    console.log('🌍 No navigator locale detected, using fallback: it');
    return 'it';
  }

  // Extract base language (e.g., 'en-US' -> 'en', 'it-IT' -> 'it')
  const baseLocale = navigatorLocale.split('-')[0].toLowerCase();

  // Check if we support this locale
  if (SUPPORTED_LOCALES.includes(baseLocale)) {
    console.log(`🌍 Detected locale: ${navigatorLocale} -> using: ${baseLocale}`);
    return baseLocale;
  }

  // Default to Italian for unsupported locales
  console.log(`🌍 Unsupported locale: ${navigatorLocale}, using fallback: it`);
  return 'it';
}

/**
 * Change the current locale and persist to localStorage
 * @param {string} newLocale - The locale to switch to ('en' or 'it')
 */
function setLocale(newLocale) {
  if (!SUPPORTED_LOCALES.includes(newLocale)) {
    console.warn(`🌍 Unsupported locale: ${newLocale}`);
    return;
  }
  console.log(`🌍 Switching locale to: ${newLocale}`);
  localStorage.setItem(LOCALE_STORAGE_KEY, newLocale);
  locale.set(newLocale);
}

const initPromise = init({
  fallbackLocale: 'it',
  initialLocale: getLocale(),
});

export { _, isLoading, initPromise, locale, setLocale, SUPPORTED_LOCALES };
